import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from '../../assets/logos/icare_fulllogo.png';
import TermsAndConContent from "../../components/infomodals/TermsAndConContent";
import { sendReactGAPageView } from "../../consts/helpers";

export default function TermsAndCon() {
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'Terms & Conditions of Use');
    }, [pathname])

    const navigate = useNavigate();
    const handleBackButtonClick = () => {
        navigate(-1)
    }

    return (
        <>
        <Stack direction={'row'} spacing={1} sx={{ pt: '32px' }} className="centered-y">
            <IconButton onClick={handleBackButtonClick}>
                <ArrowBack />
            </IconButton>
            <Typography variant="h5">iCare Terms & Conditions</Typography>
        </Stack>

        <Box display="flex" justifyContent="center">
            <img src={logo} alt='icare app logo' style={{ maxWidth: 300 }}/>
        </Box>
        
        <TermsAndConContent sx={{ maxWidth: '100%', mx: 'auto', padding: 3 }}/>
        </>
   );
}